import { Component } from '@angular/core';

import { LernformFacettenService } from '../../../../services/facetten/instance/lernformen-facetten/lernformfacetten.service';
import { VorortLernformService } from '../../../../services/facetten/instance/lernformen-facetten/vorortlernform.service';
import { UnterrichtsformBasisFacetteComponent } from '../unterrichtsform-basis-facette/unterrichtsform-basis-facette.component';

@Component({
  selector: 'now-wbsuche-lib-vorort-facette',
  templateUrl: './vorort-facette.component.html',
  imports: [UnterrichtsformBasisFacetteComponent],
  providers: [
    // Hier wird der LernformFacettenService injected, welcher dann in der UnterrichtsFormBasisFacette verwendet werden kann
    { provide: LernformFacettenService, useExisting: VorortLernformService }
  ]
})
export class VorortFacetteComponent {}
